export const SITE = {
  name: "Nexus Catalyst Agency",
  shortName: "Nexus Catalyst",
  email: "nexuscatalystagency@gmail.com",
  phone: "+917984053174",
  phoneDisplay: "+91 79840 53174",
  whatsappNumber: "917984053174",
  whatsappMessage:
    "Assalamu alaikum. I'd like to discuss growth marketing for my Hajj & Umrah travel agency.",
  blueprintUrl:
    "https://drive.google.com/file/d/1WFRSwD8Wmv3SGFv-puJz8pT26yZecwx1/view?usp=sharing",
  socials: {
    instagram: "https://www.instagram.com/nexuscatalystagency/",
    facebook: "https://www.facebook.com/profile.php?id=61570099645334",
    linkedin: "",
  },
};

export const whatsappHref = (fallback = "/contact") =>
  SITE.whatsappNumber
    ? `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(SITE.whatsappMessage)}`
    : fallback;
